import React from "react"
import { Pagination, PaginationItem } from "@material-ui/lab"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import useStyles from "./styles"
import { Select, MenuItem } from "@material-ui/core"

const Paginate = ({ page, setLimit }) => {

    const { numberOfPages } = useSelector((state) => state.posts)
    const classes = useStyles()

    const numberChange = (e) => {
        setLimit(e.target.value)
    }

    return (
        <div className={classes.pagination_content}>
            <Pagination
                siblingCount={0}
                className={classes.pagination_core}
                classes={{ ul: classes.ul }}
                count={numberOfPages}
                page={Number(page) || 1}
                variant="outlined"
                color="primary"
                renderItem={(item) => (
                    <PaginationItem {...item} component={Link} to={`/rss?page=${item.page}`} />
                )}
            />
            <Select onChange={numberChange} defaultValue="3">
                <MenuItem value="3">3</MenuItem >
                <MenuItem value="5">5</MenuItem >
                <MenuItem value="10">10</MenuItem >
                <MenuItem value="25">25</MenuItem >
            </Select>
        </div>


    )
}

export default Paginate